<template>
  <svg
    version="1.1"
    id="Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 244.3 226.7"
    style="enable-background:new 0 0 244.3 226.7;"
    xml:space="preserve"
    class="circle_svg"
  >
    <title>{{$t('titles.circle')}}</title>
    <rect class="circle_tool" width="244.3" height="226.7"></rect>
    <linearGradient
      id="SVGID_circle"
      gradientUnits="userSpaceOnUse"
      x1="35.8101"
      y1="-730.4099"
      x2="201.3601"
      y2="-730.4099"
      gradientTransform="matrix(1 0 0 -1 0 -617.9399)"
    >
      <stop offset="0" style="stop-color:#AD3925"></stop>
      <stop offset="1" style="stop-color:#F16624"></stop>
    </linearGradient>
    <path
      class="circle_tool_1"
      d="M118.6,31L118.6,31c44.3,0,80.3,35.9,80.3,80.3v2.4c0,44.3-35.9,80.3-80.3,80.3h0c-44.3,0-80.3-35.9-80.3-80.3
	v-2.4C38.3,66.9,74.2,31,118.6,31z"
    ></path>
  </svg>
</template>
<script>
export default {
  name: "circleTool"
};
</script>

<style>
.circle_tool {
  fill: #252624;
}
.circle_tool_1 {
  fill: none;
  stroke: url(#SVGID_circle);
  stroke-width: 5;
  stroke-miterlimit: 10;
}
.circle_svg {
  position: absolute;
  background: transparent;
  width: 65px;
  height: 57px;
  top: -23px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  margin-left: 87px;
}
.theme--dark.v-btn-toggle {
    background: #42424200 !important;
}
</style>
